import React, { useContext, useMemo, useRef, useEffect } from 'react';
import { noop } from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { TextAssetCollectionWithRecommendations } from './text-asset-collection-with-recommendations';
import { getTextAssetCollectionConfig } from './pmax-text-asset-collection-config';
import { getTextAssetCollectionConfigByFeature } from './utils';

export const DescriptionAssetCollection = React.memo((props) => {
  const {
    featureName, enableCopilotRecommendations, enableCustomizer, isOptional, withDeleteIconDisabled, showDeleteButton, renderInlineCopilot, setAddNewDescriptionCallback, onFocusTextAsset, onDeleteTextAsset, onApplyRecommendation,
  } = props;
  const i18n = useContext(I18nContext);
  const textAssetCollectionConfig = useMemo(() => getTextAssetCollectionConfigByFeature({ featureName }), [featureName]);

  const descriptionsConfig = useMemo(() => getTextAssetCollectionConfig('descriptions', i18n, textAssetCollectionConfig), [i18n, textAssetCollectionConfig]);
  const addNewHeadlinesCallback = useRef(noop);

  useEffect(() => {
    if (setAddNewDescriptionCallback) {
      setAddNewDescriptionCallback(() => (recommendations) => {
        addNewHeadlinesCallback.current(recommendations);
      });
    }
  }, [setAddNewDescriptionCallback]);

  return (
    <div className="description-asset-collection">
      <TextAssetCollectionWithRecommendations
        {...descriptionsConfig}
        isOptional={isOptional}
        showDeleteButton={showDeleteButton}
        onDeleteTextAsset={onDeleteTextAsset}
        onApplyRecommendation={onApplyRecommendation}
        renderInlineCopilot={renderInlineCopilot}
        i18n={i18n}
        onFocusTextAsset={onFocusTextAsset}
        withInlineRecommendations
        setAddTextAssetCallback={(callback) => { addNewHeadlinesCallback.current = callback; }}
        enableCopilotRecommendations={enableCopilotRecommendations}
        enableCustomizer={enableCustomizer}
        withDeleteIconDisabled={withDeleteIconDisabled}
      />
    </div>);
});

DescriptionAssetCollection.propTypes = {
  isOptional: PropTypes.bool,
  showDeleteButton: PropTypes.bool,
  onDeleteTextAsset: PropTypes.func,
  onApplyRecommendation: PropTypes.func,
  renderInlineCopilot: PropTypes.func,
  setAddNewDescriptionCallback: PropTypes.func,
  onFocusTextAsset: PropTypes.func,
  featureName: PropTypes.string,
  enableCopilotRecommendations: PropTypes.bool,
  enableCustomizer: PropTypes.bool,
  withDeleteIconDisabled: PropTypes.bool,
};

DescriptionAssetCollection.defaultProps = {
  isOptional: false,
  showDeleteButton: false,
  onDeleteTextAsset: noop,
  onApplyRecommendation: noop,
  renderInlineCopilot: null,
  setAddNewDescriptionCallback: null,
  onFocusTextAsset: noop,
  featureName: undefined,
  enableCopilotRecommendations: true,
  enableCustomizer: false,
  withDeleteIconDisabled: true,
};
